import { render, staticRenderFns } from "./appltUserCode.vue?vue&type=template&id=ca44bb30&scoped=true"
import script from "./appltUserCode.vue?vue&type=script&lang=js"
export * from "./appltUserCode.vue?vue&type=script&lang=js"
import style0 from "./appltUserCode.vue?vue&type=style&index=0&id=ca44bb30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca44bb30",
  null
  
)

export default component.exports